import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'

// AIzaSyCFEYtfpxvK5yJq2HGVi10vksikyh3KjEQ
Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyBgUWNDUD4nazjxC-mBs5T7vnhJYYIVyUM',
        libraries: 'places,directions,geometry'
    }
})


// WEBPACK FOOTER //
// ./resources/assets/js/plugins/maps.js